import { render, staticRenderFns } from "./EmdFooter.vue?vue&type=template&id=53d2ef01&scoped=true"
import script from "./EmdFooter.vue?vue&type=script&lang=js"
export * from "./EmdFooter.vue?vue&type=script&lang=js"
import style0 from "./EmdFooter.vue?vue&type=style&index=0&id=53d2ef01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d2ef01",
  null
  
)

/* custom blocks */
import block0 from "./EmdFooter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports